import { useState } from 'react';
import { Box, Button, Spinner, Text, TextField } from '@stitch-fix/mode-react';
import { formatMoney } from '@stitch-fix/format';
import { useRedeemPromoCodeMutation } from '../../graphql/RedeemPromoCode';
export const PromoCodeInputField = () => {
  const [code, setCode] = useState('');
  const [redeemedMessage, setRedeemedMessage] = useState('');
  const [helpText, setHelpText] = useState('');
  const [redeemPromoCodeMutation, {
    loading
  }] = useRedeemPromoCodeMutation({
    onCompleted: data => {
      const result = data.redeemPromoCode?.result;

      // eslint-disable-next-line no-underscore-dangle
      if (result?.__typename === 'RedeemPromoCodeSuccess') {
        const discount = result.promoCode.discount;
        let successMessage = 'Your promo code was redeemed successfully!';

        // eslint-disable-next-line no-underscore-dangle
        if (discount?.__typename === 'DiscountPercentage') {
          successMessage = `Your ${discount.percentage}% promo code was redeemed successfully!`;
        } else if (
        // eslint-disable-next-line no-underscore-dangle
        discount?.__typename === 'DiscountFixed' && discount.amount) {
          successMessage = `Your ${formatMoney(discount.amount.value, {
            inCents: true
          })} promo code was redeemed successfully!`;
        }
        setRedeemedMessage(successMessage);
        setCode('');
        // eslint-disable-next-line no-underscore-dangle
      } else if (result?.__typename === 'RedeemPromoCodeError') {
        setHelpText(result.message || 'Invalid promo code.');
      }
    },
    onError: error => {
      setHelpText(error.message || 'Something went wrong.');
    }
  });
  const handleRedeem = async () => {
    setRedeemedMessage('');
    setHelpText('');
    await redeemPromoCodeMutation({
      variables: {
        input: {
          code
        }
      }
    });
  };
  const handleCodeChange = (newCode: string) => {
    if (redeemedMessage) setRedeemedMessage('');
    if (helpText) setHelpText('');
    setCode(newCode);
  };
  const textFieldState = helpText ? 'error' : 'default';
  return <>
      <TextField width="375px" name="promo-code" label="Promo Code" value={code} onChange={handleCodeChange} state={textFieldState} helpText={helpText} />
      {redeemedMessage && <Box aria-live="polite" role="status">
          <Text color="lime-50" setting="body-medium" align="center" mt={1}>
            {redeemedMessage}
          </Text>
        </Box>}
      <Button width="fill" mt={1} disabled={!code || loading} onClick={handleRedeem} startIcon={loading && <Spinner variant="process" size="xsmall" />}>
        Redeem Promo Code
      </Button>
    </>;
};